import { cn, iaRa } from 'lib/helpers/utility';

import DocText from '../DocText';
import { DOC_TEXT } from '../lib/docStyles';

/**
 * @param {object} params
 * @param {Array<{label: string, value: any, lines?: string[], className?: string}>} params.entries
 * @param {string} [params.columnsClass] - Grid template override, e.g. for the
 *   invoice's 1.6fr/1fr/1fr split.
 */
const DocFieldGrid = ({ entries = [], columnsClass = 'grid-cols-3', className }) => {
  const visibleEntries = iaRa(entries).filter((entry) => entry?.value || iaRa(entry?.lines).length);

  if (!visibleEntries.length) return null;

  return (
    <div className={cn('grid gap-x-6 gap-y-2.5 xs:grid-cols-1', columnsClass, className)}>
      {visibleEntries.map((entry) => (
        <div key={entry.label} className={cn('min-w-0', entry.className)}>
          <DocText variant="label" size="small" className={DOC_TEXT.microLabel}>
            {String(entry.label).toUpperCase()}
          </DocText>
          {entry.value && (
            <DocText className={cn(DOC_TEXT.fieldValue, 'mt-0.5')}>{entry.value}</DocText>
          )}
          {iaRa(entry.lines).map((line, index) => (
            <DocText key={`${entry.label}-line-${index}`} size="xs" className={DOC_TEXT.meta}>
              {line}
            </DocText>
          ))}
        </div>
      ))}
    </div>
  );
};

export default DocFieldGrid;
